module.exports = __webpack_public_path__ + "img/torne-se-assinante.2b64b105.jpg";